import { c as _c } from "react/compiler-runtime";
import { useSheetManager } from '@/lib/ui';
import { useBrowserNavigation } from '@/lib/ui/BrowserNavigationContext';
import type { SheetNavigationList, SheetNavigationItem } from '@/lib/ui/SheetManager';
import ItemDetailView from '@/components/ItemDetailView';
interface ShowItemDetailOptions {
  showReactions?: boolean;
  showComments?: boolean;
  keepOpenOnRouteChange?: boolean;
  /** Navigation list for prev/next browsing through items. When omitted, falls back to browser context. */
  navigationList?: SheetNavigationList;
}
export function useItemDetailSheet() {
  const $ = _c(3);
  const {
    openSheet
  } = useSheetManager();
  const {
    itemNavigationList
  } = useBrowserNavigation();
  let t0;
  if ($[0] !== itemNavigationList || $[1] !== openSheet) {
    const showItemDetail = (itemId, options) => {
      const navList = options?.navigationList ?? itemNavigationList;
      openSheet({
        id: `item-detail-${itemId}`,
        title: "Item Details",
        content: <ItemDetailView id={itemId} showReactions={options?.showReactions ?? true} showComments={options?.showComments ?? true} />,
        maxWidth: "sm:max-w-4xl",
        keepOpenOnRouteChange: options?.keepOpenOnRouteChange ?? false,
        navigationList: navList,
        currentNavigationId: navList ? itemId : undefined
      });
    };
    t0 = {
      showItemDetail
    };
    $[0] = itemNavigationList;
    $[1] = openSheet;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}

/** Helper to build a navigation list for items */
export function buildItemNavigationList(items: Array<{
  id: string | number;
  name?: string;
}>, options?: {
  showReactions?: boolean;
  showComments?: boolean;
}): SheetNavigationList {
  return {
    items: items.map(i => ({
      id: String(i.id),
      title: i.name || 'Item Details'
    })),
    renderContent: (item: SheetNavigationItem) => <ItemDetailView id={item.id} showReactions={options?.showReactions ?? true} showComments={options?.showComments ?? true} />,
    maxWidth: 'sm:max-w-4xl'
  };
}